module.exports = __webpack_public_path__ + "static/rings-fc51e7c41df991693b9b7bb384740239.png";